import { render, staticRenderFns } from "./GroupTaxaSearch.vue?vue&type=template&id=16dd25d4"
import script from "./GroupTaxaSearch.vue?vue&type=script&lang=js"
export * from "./GroupTaxaSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports